class Address {
  constructor(
    companyName,
    contactName,
    attention,
    line1,
    line2,
    city,
    state,
    zipCode,
    country,
    phoneNumber,
    id,
  ) {
    this.companyName = companyName;
    this.contactName = contactName;
    this.attention = attention;
    this.line1 = line1;
    this.line2 = line2;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.country = country;
    this.phoneNumber = phoneNumber;
    this.id = id;
  }
}
export default Address;
